import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils/cn";

import timer from "../../../assets/stopwatch-icon.svg";
import Modal from "@assessment/components/atoms/modal";
import TimesUpModal from "./timesUpModal";
import useAssessmentTimer from "@assessment/hooks/useAssessmentTimer";
import { useAppDispatch, useAppSelector } from "@assessment/store/store";
import { AssessmentSliceActions } from "@assessment/store/slices/assessmentSlice";

interface Props {
  timeInSeconds?: number;
  qpDuration: number;
}
const AssessmentTimer = ({ qpDuration }: Props) => {
  const { t } = useTranslation();
  // const [timeLeft, setTimeLeft] = useState(10);
  const duration = useAppSelector((store) => store.AssessmentSlice.timeLeft);

  const { timeLeft, paddedHours, paddedMinutes, paddedSeconds } =
    useAssessmentTimer({ initialTime: duration });
  const dispatch = useAppDispatch();
  // const hours = Math.floor(timeLeft / 3600);
  // const minutes = Math.floor((timeLeft % 3600) / 60);
  // const seconds = timeLeft % 60;

  // const paddedHours = String(hours).padStart(2, "0");
  // const paddedMinutes = String(minutes).padStart(2, "0");
  // const paddedSeconds = String(seconds).padStart(2, "0");

  const percentage = (timeLeft / duration) * 100;

  const showWarning = percentage <= 10;

  const TEST_TERMINATE_AT = 2;
  const timesUpModalOpen = useAppSelector(
    (store) => store.AssessmentSlice.timesUpModalOpen
  );

  useEffect(() => {
    if (timeLeft === TEST_TERMINATE_AT) {
      dispatch(AssessmentSliceActions.mutateTimesUpModalOpen(true));
    }
  }, [timeLeft]);

  return (
    <>
      <div
        data-tour="ad-timer"
        className={cn(
          "flex items-center gap-2 px-4 py-2 border border-border rounded-lg min-w-[9rem] text-white",
          !showWarning && "bg-secondary dark:bg-[#3b3b3b]",
          showWarning && "bg-[#FF584E]",
          timeLeft <= 10 && timeLeft > 0 && "animate-pulse"
        )}
      >
        <div
          className="flex items-center"
          style={{ textAlign: "center", width: "20px" }}
        >
          <div className="flex items-center justify-center w-5 h-5 shrink-0">
            <img className="w-full h-full" src={timer} alt="timer" />
          </div>
        </div>
        <span
          className={cn(
            "flex text-base gap-2 font-medium tracking-wide items-center justify-center"
          )}
        >
          <p className="flex items-baseline">
            <span className="font-semibold">{paddedHours}</span>
            <span className="align-sub text-xs">
              {t("assessment.time.hourShort")}
            </span>
          </p>
          <p className="flex items-baseline mt-0">
            <span className="font-semibold">{paddedMinutes}</span>
            <span className="align-sub text-xs">
              {t("assessment.time.minuteShort")}
            </span>
          </p>
          <p className="flex items-baseline mt-0">
            <span className="font-semibold">{paddedSeconds}</span>
            <span className="align-sub text-xs">
              {t("assessment.time.secondShort")}
            </span>
          </p>
        </span>
      </div>
      {timesUpModalOpen && (
        <Modal
          children={<TimesUpModal />}
          open={timesUpModalOpen}
          childDialogTitle={t("assessment.timesUp.title")}
          dialogueClassName="w-fit"
          closeBtn={true}
        />
      )}
    </>
  );
};

export default AssessmentTimer;
